import { render, staticRenderFns } from "./OutcomesCollapsableOrder.vue?vue&type=template&id=b4efec3e&"
import script from "./OutcomesCollapsableOrder.vue?vue&type=script&lang=js&"
export * from "./OutcomesCollapsableOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports